import React from "react";
import { createRoot } from "react-dom/client";
import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { routerForBrowser, initializeCurrentLocation } from "../shared_components/little_router";

import Root from "./containers/root";
import makeMainReducer from "./reducers";
import { ajaxRequestMiddleware, sagaMiddleware, routerSectionChangedMiddleware, loggingMiddleware } from "./middlewares";
import rootSaga from "./sagas";

class TariffSurveyHubApp {
  constructor(htmlNode, propsAndState) {
    const routes = {
      "/:section": {
        "/:tab": {}
      }
    };

    const {
      reducer,
      middleware,
      enhancer
    } = routerForBrowser({
      routes,
      basename: "/data-hub/tariff-survey"
    });

    const composeEnhancers =
      typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

    const initialState = propsAndState;
    const mainReducer = makeMainReducer(initialState);

    const mids = applyMiddleware(middleware,
                                 loggingMiddleware,
                                 routerSectionChangedMiddleware,
                                 ajaxRequestMiddleware,
                                 sagaMiddleware);
    const finalEnhancer = composeEnhancers(
      enhancer, mids
    );

    const store = createStore(
      combineReducers({
        main: mainReducer,
        router: reducer
      }),
      initialState,
      finalEnhancer);

    this.store = store;

    sagaMiddleware.run(rootSaga);

    const initialLocation = store.getState().router;
    if (initialLocation) {
      store.dispatch(initializeCurrentLocation(initialLocation));
    }

    const wrapApp = (AppComponent, reduxStore) =>
    <Provider store={reduxStore}>
      <AppComponent {...propsAndState.props} />
    </Provider>;

    createRoot(htmlNode).render(wrapApp(Root, store));
  }
}

export default TariffSurveyHubApp;
